/** Root-owned port of OpenCode text-shimmer, retaining its CSS/DOM contract. */
import type { ElementType } from "react";
import { useTextShimmer } from "../state/presentation/shimmer-react.tsx";
import { shimmerSwapMs } from "../state/presentation/shimmer-model.ts";

export interface TextShimmerProps {
  text: string;
  className?: string;
  as?: ElementType;
  active?: boolean;
  offset?: number;
}

export function TextShimmer({
  text,
  className,
  as: Component = "span",
  active = true,
  offset = 0
}: TextShimmerProps) {
  const run = useTextShimmer(active);

  return (
    <Component
      data-component="text-shimmer"
      data-active={active ? "true" : "false"}
      className={className}
      aria-label={text}
      style={{
        ["--text-shimmer-swap"]: `${shimmerSwapMs}ms`,
        ["--text-shimmer-index"]: `${offset}`
      }}
    >
      <span data-slot="text-shimmer-char">
        <span data-slot="text-shimmer-char-base" aria-hidden="true">
          {text}
        </span>
        <span
          data-slot="text-shimmer-char-shimmer"
          data-run={run ? "true" : "false"}
          aria-hidden="true"
        >
          {text}
        </span>
      </span>
    </Component>
  );
}
